import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const defaultFaqs = [
  { question: "Bagaimana cara melaporkan kejadian bencana?", answer: "Anda dapat melapor melalui formulir Lapor Bencana di halaman Layanan situs ini, atau menghubungi Call Center darurat 112 yang beroperasi 24 jam." },
  { question: "Apa saja jenis bencana yang sering terjadi di Kayong Utara?", answer: "Bencana yang berpotensi terjadi antara lain banjir, kebakaran hutan dan lahan (karhutla), angin puting beliung, tanah longsor, dan abrasi pantai." },
  { question: "Bagaimana cara mendapatkan bantuan pasca bencana?", answer: "Korban bencana dapat mengajukan permohonan bantuan melalui pemerintah desa/kelurahan setempat yang kemudian diverifikasi oleh tim BPBD untuk penyaluran bantuan." },
  { question: "Bagaimana cara menjadi relawan penanggulangan bencana?", answer: "Silakan datang ke kantor BPBD Kayong Utara untuk mendaftar sebagai relawan, atau bergabung dengan program Desa Tangguh Bencana di wilayah Anda." },
  { question: "Bagaimana cara meminta data atau informasi publik dari BPBD?", answer: "Permohonan informasi publik diajukan melalui PPID BPBD dengan mengisi formulir permohonan dan melampirkan identitas. Tanggapan diberikan maksimal 10 hari kerja." },
];

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);
  const list = faqs.length ? faqs : defaultFaqs;
  return (
    <div data-testid="faq-page">
      <PageHeader title="Pertanyaan yang Sering Diajukan" subtitle="Jawaban atas pertanyaan umum seputar layanan BPBD Kabupaten Kayong Utara" />
      <section className="max-w-3xl mx-auto px-4 py-16">
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {list.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border border-slate-200 rounded px-5 bg-white">
              <AccordionTrigger className="font-heading font-semibold text-slate-900 text-left hover:text-orange-600" data-testid={`faq-trigger-${i}`}>
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm leading-relaxed">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
